import {
  Checkbox,
  Input,
  DatePicker,
  Select,
  Option,
  CheckboxGroup,
  CheckboxButton,
  Popover,
  Button,
} from 'element-ui';
import VueTimepicker from 'vue2-timepicker';
import ResourceSvc from '@/services/resource.svc.js';
import { EventBus } from '@/services/Event.js';
const Request = new ResourceSvc();
import RaceDetails from '@/components/user/race-events/race-entry/race-details/race-details.vue';
import 'vue2-timepicker/dist/VueTimepicker.css';
import Tbanner from '@/components/user/race-events/race-components/web-banner-2022.vue';

export default {
  name: 'RaceEntry',
  components: {
    'race-details': RaceDetails,
    [VueTimepicker.name]: VueTimepicker,
    [Checkbox.name]: Checkbox,
    [Input.name]: Input,
    [Select.name]: Select,
    [Option.name]: Option,
    [DatePicker.name]: DatePicker,
    [CheckboxButton.name]: CheckboxButton,
    [CheckboxGroup.name]: CheckboxGroup,
    [Popover.name]: Popover,
    [Button.name]: Button,
    't-banner': Tbanner,
  },
  data() {
    return {
      userCookies: null,
      isProcessing: false,
      isError: true,
      isContinueRegistration: false,
      isShowRegistrationForm: false,
      isShowCard: false,
      registerAgain: false,
      isRegisteredAll: false,
      environmentProperties: [],
      juniorAccountList: [],
      accountsList: [],
      cardDetails: [],
      raceDetails: [],
      raceRegistrationDetails: [],
      raceRegistrationResult: [],
      racesList: [],
      no: 'No',
      registerTypes: ['Individual', 'Relay'],
      selectedRegisterType: null,
      selectedAthlet: null,
      isSelectedAthletRegistrationCompleted: true,
      notCompletedProfileRequiredFields: '',
      isShowSuccess: false,
      successMessage: '',
      errorMessage: '',
      cooponCode: null,
      isShowCoopon : false,
      isValidationMessage: false,
      isValidationMandatoryMerchandiseMessage: false,
      isForIndividualsOnly: false,

      relayName: null,
      relayCaptain: null,
      relayAthlet2: null,
      relayAthlet3: null,
      relayAthlet4: null,
      selectedRelayIds: [],
      selectedRelayIdsView: [],

      isEverDoneTriathlon: false,
      isAcceptedTerms: false,
      isMarketingInfoAccepted: false,
      whereHear: '',
      whatSchool: '',
      medicalAnswer: '',
      extraAnswer: '',
      askSwimTIme: '00:00:00',
      askBikeTime: '00:00:00',
      askRunTime: '00:00:00',

      competitionCategory: null,
      competitionCategories: [
        { value: 0, label: 'Female' },
        { value: 1, label: 'Open' }
      ],

      selectedMerchSize: null,
      selectedMerchAmount: null,
      selectedRace: null,
      merchAmounts: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
      selectedMerchList: [],
    };
  },
  watch: {
    selectedRegisterType: {
      handler(newVal, oldVal) {
        this.raceRegistrationDetails = [];
        this.selectedAthlet = null;
      },
    },
    selectedAthlet: {
      handler(newVal, oldVal) {
        if (newVal) {
          if (this.registerAgain) {
            this.getRacesCMS(newVal);
          } else {
            this.getRaceDetailForUser(newVal, null);
          }
        }
      },
    },
    selectedRace: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.getRaceDetailForUser(this.selectedAthlet, newVal);
          this.loadRaceInfo(newVal);
        }
      },
    },
  },
  computed: {
    isValidInput() {
      let validArray = [];
      if (this.raceRegistrationDetails.raceDetail.askWhatSchool) {
        validArray.push(this.isValidWhatSchool);
      }
      if (this.raceRegistrationDetails.raceDetail.askWhereHear) {
        validArray.push(this.isValidWhereHear);
      }
      if (this.raceRegistrationDetails.raceDetail.askBikeTime) {
        validArray.push(this.isValidBikeTIme);
      }
      if (this.raceRegistrationDetails.raceDetail.askSwimTime) {
        validArray.push(this.isValidSwimTIme);
      }
      if (this.raceRegistrationDetails.raceDetail.askRunTime) {
        validArray.push(this.isValidRunTIme);
      }

      validArray.push(this.isValidMedicalAnswer);
      validArray.push(this.isAcceptedTerms);
      validArray.push(this.isValidCompetitionCategory);
      if (validArray.some(x => x == false)) {
        return false;
      } else {
        return true;
      }
    },
    isValidRelayInput() {
      let self = this;
      let validArray = [];
      if (self.relayAthlet3 && self.relayAthlet3.length) {
        validArray.push(self.isValidRelayAthlet3);
      }
      if (self.relayAthlet4 && self.relayAthlet4.length) {
        validArray.push(self.isValidRelayAthlet4);
      }
      validArray.push(self.isValidRelayCaptain);
      validArray.push(self.isValidRelayAthlet2);
      validArray.push(self.isValidRelayName);
      if (validArray.some(x => x == false)) {
        return false;
      } else {
        return true;
      }
    },
    isValidSwimTIme() {
      return (
        this.askSwimTIme != null &&
        this.askSwimTIme.length &&
        this.askSwimTIme != '00:00:00' &&
        isNaN(this.askSwimTIme.split(':')) &&
        !this.askSwimTIme.includes('HH') &&
        !this.askSwimTIme.includes('mm') &&
        !this.askSwimTIme.includes('ss')
      );
    },
    isValidRunTIme() {
      return (
        this.askRunTime != null &&
        this.askRunTime.length &&
        this.askRunTime != '00:00:00' &&
        isNaN(this.askRunTime.split(':')) &&
        !this.askRunTime.includes('HH') &&
        !this.askRunTime.includes('mm') &&
        !this.askRunTime.includes('ss')
      );
    },
    isValidBikeTIme() {
      return (
        this.askBikeTime != null &&
        this.askBikeTime.length &&
        this.askBikeTime != '00:00:00' &&
        isNaN(this.askBikeTime.split(':')) &&
        !this.askBikeTime.includes('HH') &&
        !this.askBikeTime.includes('mm') &&
        !this.askBikeTime.includes('ss')
      );
    },
    isValidWhatSchool() {
      if (this.whatSchool && this.whatSchool.length) {
        return true;
      } else {
        return false;
      }
    },
    isValidRelayName() {
      if (this.relayName && this.relayName.length) {
        return true;
      } else {
        return false;
      }
    },
    isValidWhereHear() {
      if (this.whereHear && this.whereHear.length) {
        return true;
      } else {
        return false;
      }
    },
    isValidMedicalAnswer() {
      if (this.medicalAnswer && this.medicalAnswer.length) {
        return true;
      } else {
        return false;
      }
    },
    isValidCompetitionCategory() {
      return this.competitionCategory !== null && this.competitionCategory !== undefined;
    },
    isValidRelayCaptain() {
      if (this.isValidUserId(this.relayCaptain)) {
        return Number(this.relayCaptain);
      }
      return null;
    },
    isValidRelayAthlet2() {
      if (this.isValidUserId(this.relayAthlet2)) {
        return Number(this.relayAthlet2);
      }
      return null;
    },
    isValidRelayAthlet3() {
      if (this.isValidUserId(this.relayAthlet3)) {
        return Number(this.relayAthlet3);
      }
      return null;
    },
    isValidRelayAthlet4() {
      if (this.isValidUserId(this.relayAthlet4)) {
        return Number(this.relayAthlet4);
      }
      return null;
    },
    isMerchDescription() {
      return (
        (this.raceRegistrationDetails.raceMerchandises[0] &&
          this.raceRegistrationDetails.raceMerchandises[0].description) ||
        (this.raceRegistrationDetails.raceMerchandises[1] &&
          this.raceRegistrationDetails.raceMerchandises[1].description) ||
        (this.raceRegistrationDetails.raceMerchandises[2] &&
          this.raceRegistrationDetails.raceMerchandises[2].description)
      );
    },
    isSelectedMerchDescription() {
      if (this.selectedMerchList && this.selectedMerchList.length) {
        return this.selectedMerchList.forEach(x => x.Description);
      } else return false;
    },
    cookiesValue() {
      if (!this.userCookies) {
        return;
      }
      let str = '';
      this.userCookies.forEach(x => {
        str += x.key + '=' + x.value + '; ';
      });
      return '"' + str.trimEnd() + '"';
    },
    selectedRelayIdsString() {
      if (!self.isValidRelayInput) {
        return;
      }
      return this.selectedRelayIds.join(',');
    },
    isShowCardBlock() {
      if (
        this.isShowCard &&
        this.cardDetails &&
        this.cardDetails.CustomObject.RaceRegistrationItems &&
        this.cardDetails.CustomObject.RaceRegistrationItems.length == 0 &&
        this.cardDetails.ResponseStatus == 1 &&
        !this.isContinueRegistration
      ) {
        this.continueRaceRegistration();
        this.registerAgain = false;
      }

      return (
        this.isShowCard &&
        this.cardDetails &&
        this.cardDetails.CustomObject.RaceRegistrationItems &&
        this.cardDetails.CustomObject.RaceRegistrationItems.length &&
        this.cardDetails.ResponseStatus == 1 &&
        !this.isContinueRegistration
      );
    },
    getCurrentUser() {
      if (
        !this.raceRegistrationDetails ||
        !this.raceRegistrationDetails.relayUsers
      )
        return '';
      let data = this.raceRegistrationDetails.relayUsers.filter(
        item => item.userId == this.selectedRelayIds[0]
      )[0];
      return data
        ? `${data.userFullName} (${this.$getTriathlonId(data.userId)})`
        : '';
    },
    isMandatoryMerchandiseBuy() {
      let hasMandatoryMerchandise = true;

      let raceMerchandiseItems =
        this.raceRegistrationDetails.raceMerchandises.filter(
          item => item.isRequiredToBuy == true
        );

      if (raceMerchandiseItems.length == 0) return hasMandatoryMerchandise;

      let selectedMerchItems = this.selectedMerchList.filter(
        item => item.isRequiredToBuy == true
      );

      raceMerchandiseItems.forEach(item => {
        hasMandatoryMerchandise =
          hasMandatoryMerchandise &&
          selectedMerchItems.some(x => x.MerchandiseId == item.Id);
      });
      return hasMandatoryMerchandise;
    },
  },
  methods: {
    reloadPage() {
      window.location.reload();
    },
    isValidUserId(id) {
      if (id && id.indexOf(' ') > -1) {
        id = id.split(' ').join('');
      }
      return !isNaN(id) && id && id.length > 6;
    },
    async loadCartNew() {
      var self = this;
      self.isShowCard = false;
      self.isProcessing = true;

      await Request.getCartNew().then(
        res => {
          self.isProcessing = false;
          if (res && res.body && res.body.isSuccess) {
            self.cardDetails.CustomObject = {
              RaceRegistrationItems: res.body.outputData.tiRaceRegistration,
              TotalCostBeforeDiscount:
                res.body.outputData.totalCostBeforeDiscount,
              TotalDiscount: res.body.outputData.totalDiscount,
              TotalPrice: res.body.outputData.totalPrice,
            };
            self.cardDetails.ResponseStatus = 1;
            self.isShowCard =
              res.body.outputData.tiRaceRegistration &&
              res.body.outputData.tiRaceRegistration.length > 0;
          } else {
            self.isProcessing = false;
            self.$showError(
              res && res.body && res.body.message ? res.body.message : null,
              5000
            );
          }
        },
        err => {
          self.isProcessing = false;
          self.$showError(5000);
        }
      );
    },
    async loadRaceInfo(rId) {
      let self = this;
      let raceId;
      if (!rId) {
        raceId =
          this.$route.params.rId && this.$route.params.rId != null
            ? this.$route.params.rId
            : null;
      } else {
        raceId = rId;
      }
      if (raceId && raceId != null) {
        self.raceDetails = [];
        self.isProcessing = true;
        await Request.raceCalendarCardInfo(raceId).then(
          res => {
            self.isProcessing = false;
            if (res && res.body && res.body.isSuccess) {
              self.raceDetails = res.body.outputData[0];

              const openPlacesForRelay = self.raceDetails['Open Places For Relay'];
              if (openPlacesForRelay === null || openPlacesForRelay <= 0) {
                self.isForIndividualsOnly = true;
                self.selectedRegisterType = self.registerTypes[0];
              }
            } else {
              self.$showError(
                res && res.body && res.body.message ? res.body.message : null,
                5000
              );
            }
          },
          err => {
            self.isProcessing = false;
            self.$showError(5000);
          }
        );
      }
    },
    getRaceDetailForUser(userId, raceId) {
      var self = this;
      let rId;
      if (!raceId) {
        rId = self.$route.params.rId;
      } else {
        rId = raceId;
      }

      var queryParams = {
        raceId: rId,
        userId: userId || self.selectedRelayIds[0],
        relayTypeString: self.selectedRegisterType,
        relayName: self.relayName,
        relayUserIds: self.selectedRelayIds,
      };

      self.isProcessing = true;
      Request.getRaceDetailForUser(queryParams).then(
        res => {
          self.isProcessing = false;
          if (res && res.body && res.ok) {
            if (res.body.isSuccess) {
              self.raceRegistrationDetails = res.body.outputData;
              self.isShowRegistrationForm = true;
              self.isContinueRegistration = false;
              self.isSelectedAthletRegistrationCompleted = res.body.outputData.user && res.body.outputData.user.isRegistrationCompleted;
              self.notCompletedProfileRequiredFields = res.body.outputData.user && res.body.outputData.user.notCompletedProfileRequiredFields;
            } else if (
              res.body.redirectUrl &&
              res.body.redirectUrl.length > 0
            ) {
              window.location.href =
                process.env.url.oldApp +
                res.body.redirectUrl +
                window.location.href;
            } else {
              if (res.body && res.body.outputData && res.body.outputData.user) {
                self.isSelectedAthletRegistrationCompleted = res.body.outputData.user && res.body.outputData.user.isRegistrationCompleted;
                self.notCompletedProfileRequiredFields = res.body.outputData.user && res.body.outputData.user.notCompletedProfileRequiredFields;
              }
              else
              {
                self.isSelectedAthletRegistrationCompleted = true;
              }

              if (self.isSelectedAthletRegistrationCompleted ) {
                self.raceRegistrationDetails.message = res.body.message;
                self.$showError(res.body.message);
              }
            }
          }
        },
        err => {
          self.isProcessing = false;
          self.$showError(5000);
        }
      );
    },
    saveRaceRegistrationNew() {

      var self = this;
      self.raceRegistrationResult.Message = null;
      self.raceRegistrationResult.ResponseStatus = 0;

      if (!self.isMandatoryMerchandiseBuy) {
        self.isValidationMandatoryMerchandiseMessage = true;
        return;
      } else {
        self.isValidationMandatoryMerchandiseMessage = false;
      }

      if (!self.isValidInput) {
        self.isValidationMessage = true;
        return;
      }
      self.isValidationMessage = false;

      var queryParams = {
        raceId: self.raceRegistrationDetails.raceId,
        userId:
          self.selectedRegisterType == self.registerTypes[0]
            ? self.raceRegistrationDetails.registrationUserId
            : self.selectedRelayIds[0],
        relayTypeString: self.selectedRegisterType,
        relayName: self.relayName,
        relayUserIds: self.selectedRelayIds,
        acceptTerms: self.isAcceptedTerms,
        whereHear: self.whereHear,
        everDoneTriathlon: self.isEverDoneTriathlon,
        healthIssues: self.medicalAnswer,
        raceOpeningId: self.raceRegistrationDetails.activeRaceOpening.id,
        estimatedBikeTime:
          self.askBikeTime != '00:00:00' ? self.askBikeTime : null,
        estimatedRunTime:
          self.askRunTime != '00:00:00' ? self.askRunTime : null,
        estimatedSwimTime:
          self.askSwimTIme != '00:00:00' ? self.askSwimTIme : null,
        whatSchool: self.whatSchool,
        extraInfo: self.extraAnswer,
        competitionCategory: self.competitionCategory,
        relayRegistrationGuid:
          self.selectedRegisterType == self.registerTypes[1]
            ? self.raceRegistrationDetails.relayRegistrationGuid
            : '',
        merchandisePurchases: self.selectedMerchList,
        relayId:
          self.selectedRegisterType == self.registerTypes[1]
            ? self.raceRegistrationResult.relayId
            : undefined,
        acceptMarketingInfo: self.isMarketingInfoAccepted
      };

      self.isProcessing = true;
      Request.saveRaceRegistrationNew(queryParams).then(
        res => {
          self.isProcessing = false;
          if (res && res.body && res.ok && res.body.isSuccess) {
            self.raceRegistrationResult = res.body.outputData;
            //
            if (self.selectedRegisterType == self.registerTypes[1]) {
              const index = self.selectedRelayIds.findIndex(
                x => x == self.selectedRelayIds[0]
              );
              if (index > -1) {
                self.selectedRelayIds.splice(index, 1);
              }
              if (self.selectedRelayIds && self.selectedRelayIds.length > 0) {
                self.isEverDoneTriathlon = false;
                self.isAcceptedTerms = false;
                self.isMarketingInfoAccepted = false;
                self.whereHear = '';
                self.whatSchool = '';
                self.medicalAnswer = '';
                self.extraAnswer = '';
                self.askSwimTIme = '00:00:00';
                self.askBikeTime = '00:00:00';
                self.askRunTime = '00:00:00';
                self.selectedMerchSize = null;
                self.selectedMerchAmount = null;
                self.selectedMerchList = [];
                self.isRegisteredAll = false;
                self.raceRegistrationResult.Message =
                  'The details have been saved.';
              } else {
                self.isRegisteredAll = true;
                self.raceRegistrationResult.Message = 'Ok';
              }
              self.raceRegistrationResult.ResponseStatus = 1;
            }

            if (self.selectedRegisterType == self.registerTypes[0]) {
              self.isRegisteredAll = res.body.isSuccess;
              if (res.body.isSuccess) {
                self.raceRegistrationResult.Message = 'Ok';
                self.raceRegistrationResult.ResponseStatus = 1;
              }
            }
          } else {
            self.$showError(res.body.message);
          }
        },
        () => {
          self.isProcessing = false;
          self.$showError('Something went wrong. Contact with DEV team!');
        }
      );
    },
    getRacesCMS(userId) {
      var self = this;
      let requestHeader = {};
      if (self.selectedRegisterType == self.registerTypes[0]) {
        requestHeader = `{"IsOpenedForUser": ${userId}, "OpenedForIndividualOrRelay": "${self.selectedRegisterType}"}`;
      } else {
        requestHeader = `{"IsOpenedForUsers": "${self.selectedRelayIds.join(
          ','
        )}", "OpenedForIndividualOrRelay": "${
          self.selectedRegisterType
        }", "RaceId": ${self.$route.params.rId}}`;
      }
      self.isProcessing = true;

      Request.getRacesCMSnew(requestHeader).then(
        response => {
          self.isProcessing = false;
          if (
            response &&
            response.body &&
            response.ok &&
            response.body.isSuccess
          ) {
            self.racesList['CustomObject'] = response.body.outputData;
            self.racesList['ResponseStatus'] = 1;
          } else {
            self.$showError('Something went wrong. Contact with DEV team!');
          }
        },
        () => {
          self.isProcessing = false;
          self.$showError('Something went wrong. Contact with DEV team!');
        }
      );
    },
    async loadCookies() {
      let self = this;
      self.isProcessing = true;
      await Request.getCookies().then(
        res => {
          self.isProcessing = false;
          if (res && res.body && res.ok) {
            self.userCookies = res.body;
          } else {
            window.location.href =
              process.env.url.oldApp +
              `/login.aspx?ReturnUrl=` +
              window.location.href;
          }
        },
        err => {
          self.isProcessing = false;
          self.$showError(5000);
        }
      );
    },
    async getUserRegistrationList() {
      let self = this;
      self.isProcessing = true;
      await Request.getUserRegistrationList().then(
        res => {
          self.isProcessing = false;
          if (res && res.body && res.ok && res.body.isSuccess) {
            self.accountsList = res.body.outputData;
          } else {
            window.location.href =
              process.env.url.oldApp +
              `/login.aspx?ReturnUrl=` +
              window.location.href;
          }
        },
        err => {
          self.isProcessing = false;
          self.$showError(5000);
        }
      );
    },
    proceedToRacePaymentOld() {
      var self = this;
      self.isProcessing = true;

      let raceOpeningId =
        this.raceRegistrationDetails &&
        this.raceRegistrationDetails.activeRaceOpening
          ? this.raceRegistrationDetails.activeRaceOpening.id
          : this.cardDetails.CustomObject &&
            this.cardDetails.CustomObject.RaceRegistrationItems[0]
          ? this.cardDetails.CustomObject.RaceRegistrationItems[0].raceOpeningId
          : 0;

      Request.prepareRaceEntryTempData(
        this.$route.params.rId,
        raceOpeningId
      ).then(
        response => {
          self.isProcessing = false;
          if (
            response &&
            response.body &&
            response.ok &&
            response.body.isSuccess
          ) {
            EventBus.$emit('update-basket');
            this.$router.push({ path: response.body.redirectUrl });
          } else {
            self.isProcessing = false;
            self.$showError(response.message);
          }
        },
        () => {
          self.isProcessing = false;
          self.$showError('Something went wrong. Contact with DEV team!');
        }
      );
    },
    async checkRaceAvailability() {
      let self = this;

      self.selectedRelayIds = [];
      self.selectedRelayIdsView = [];

      let pushUsetId = function (id) {
        self.selectedRelayIds.push(self.$getUIDFromMemberNumber(id));
        self.selectedRelayIdsView.push(id);
      };

      if (self.selectedRegisterType == self.registerTypes[1]) {
        if (!self.isValidRelayInput) return;

        self.isValidRelayCaptain != null
          ? pushUsetId(self.isValidRelayCaptain)
          : null;
        self.isValidRelayAthlet2 != null
          ? pushUsetId(self.isValidRelayAthlet2)
          : null;
        self.isValidRelayAthlet3 != null
          ? pushUsetId(self.isValidRelayAthlet3)
          : null;
        self.isValidRelayAthlet4 != null
          ? pushUsetId(self.isValidRelayAthlet4)
          : null;
      }

      if (
        self.selectedRelayIds &&
        self.selectedRelayIds.filter((v, i, a) => a.indexOf(v) === i).length !=
          self.selectedRelayIds.length
      ) {
        self.$set(
          self.raceRegistrationDetails,
          'message',
          'Relay User ids are not unique!'
        );
        return;
      } else {
        self.$set(self.raceRegistrationDetails, 'message', '');
      }

      self.getRaceDetailForUser(null, null);
    },
    proceedToCheckOutClick() {
      if (!this.isMandatoryMerchandiseBuy) {
        this.isValidationMandatoryMerchandiseMessage = true;
        return;
      } else {
        this.isValidationMandatoryMerchandiseMessage = false;
      }

      this.isShowCard = true;
      this.loadCartNew();
    },
    isYes(input) {
      if (input == this.no) {
        return true;
      } else {
        return false;
      }
    },
    calculateODM(item) {
      let merchPrice = 0;
      if (item.tiMerchandisePurchase && item.tiMerchandisePurchase.length) {
        item.tiMerchandisePurchase.forEach(
          x => (merchPrice += x.price * x.amount)
        );
      }
      let OdmPrice =
        parseInt(item.price) - parseInt(item.priceRace) - merchPrice;
      return OdmPrice;
    },
    addMerchItem(item) {
      if (!item.size) {
        return null;
      }
      if (!item.amount) {
        return null;
      }
      if (
        this.selectedMerchList &&
        this.selectedMerchList.length != 0 &&
        this.selectedMerchList.some(
          x => x.merchandiseId == item.id && x.size == item.size
        )
      ) {
        const index = this.selectedMerchList.findIndex(
          x => x.merchandiseId == item.id && x.size == item.size
        );
        this.selectedMerchList[index].amount =
          parseInt(this.selectedMerchList[index].amount) +
          parseInt(item.amount);
        return;
      }
      this.selectedMerchList.push({
        description: item.description,
        merchandiseId: item.id,
        name: item.name,
        price: item.price,
        raceDetailId: item.raceDetailId,
        sizes: item.sizes,
        status: item.status,
        amount: item.amount,
        size: item.size,
        isRequiredToBuy: item.isRequiredToBuy,
      });
    },
    removeMerchItem(item) {
      const index = this.selectedMerchList.findIndex(
        x => x.merchandiseId == item.merchandiseId && x.size == item.size
      );
      if (index > -1) {
        this.selectedMerchList.splice(index, 1);
      }
    },
    removeMerchFromCart(item) {
      var self = this;
      self.isProcessing = true;
      Request.removeMerchFromCart(item.id).then(
        response => {
          self.isProcessing = false;
          if (
            response &&
            response.body &&
            response.ok &&
            response.body.isSuccess
          )
            self.loadCartNew();
        },
        () => {
          self.isProcessing = false;
          self.$showError('Something went wrong. Contact with DEV team!');
        }
      );
    },
    removeRegistration(item) {
      this.isShowCoopon = false;
      this.cooponCode = null;

      var self = this;
      self.isProcessing = true;
      Request.removeRegistrationFromCart(item.id).then(
        response => {
          self.isProcessing = false;
          if (
            response &&
            response.body &&
            response.ok &&
            response.body.isSuccess
          )
            self.loadCartNew();
        },
        () => {
          self.isProcessing = false;
          self.$showError('Something went wrong. Contact with DEV team!');
        }
      );
    },

    isOneUserAndOneRaceCouponChecker() {
      let raceOpeningIdArray = [];
      let raceRelayIdArray = [];
      let userIdArray = [];

      for (let i = 0; i < this.cardDetails.CustomObject.RaceRegistrationItems.length; i++) {
        raceOpeningIdArray.push(this.cardDetails.CustomObject.RaceRegistrationItems[i].raceOpeningId);
        raceRelayIdArray.push(this.cardDetails.CustomObject.RaceRegistrationItems[i].relayId);
        userIdArray.push(this.cardDetails.CustomObject.RaceRegistrationItems[i].user.id);
      }

      const isTheSameRace = arr => arr.every(v => v === arr[0]);

      const isNotTheRelay = arr => arr.every(v => v === null);

      if (!isNotTheRelay(raceRelayIdArray)) {
        return true;
      }

      return isTheSameRace(raceOpeningIdArray) && userIdArray.length === 1;
    },

    isTheSameRacesCouponChecker() {
      let raceOpeningIdArray = [];

      for (let i = 0; i < this.cardDetails.CustomObject.RaceRegistrationItems.length; i++) {
        raceOpeningIdArray.push(this.cardDetails.CustomObject.RaceRegistrationItems[i].raceOpeningId);
      }

      const isTheSameRace = arr => arr.every(v => v === arr[0]);
      isTheSameRace(raceOpeningIdArray);

      return !!isTheSameRace(raceOpeningIdArray);
    },

    continueRaceRegistration() {
      var self = this;
      self.isProcessing = true;

      let raceOpeningId =
        this.raceRegistrationDetails &&
        this.raceRegistrationDetails.activeRaceOpening
          ? this.raceRegistrationDetails.activeRaceOpening.id
          : this.cardDetails.CustomObject &&
          this.cardDetails.CustomObject.RaceRegistrationItems[0]
            ? this.cardDetails.CustomObject.RaceRegistrationItems[0].raceOpeningId
            : 0;

      let isProceedToPayment = false;

      Request.prepareRaceEntryTempData(
        this.$route.params.rId,
        raceOpeningId,
        isProceedToPayment
      ).then(
        response => {
          self.isProcessing = false;
          if (
            response &&
            response.body &&
            response.ok &&
            response.body.isSuccess
          ) {
            EventBus.$emit('update-basket');
          } else {
            self.isProcessing = false;
            self.$showError(response.message);
          }
        },
        () => {
          self.isProcessing = false;
          self.$showError('Something went wrong. Contact with DEV team!');
        }
      );

      this.isShowCard = false;
      this.isContinueRegistration = true;
      this.registerAgain = true;
      this.selectedRegisterType = null;
      this.selectedAthlet = null;
      this.isEverDoneTriathlon = false;
      this.isAcceptedTerms = false;
      this.isMarketingInfoAccepted = false;
      this.whereHear = '';
      this.whatSchool = '';
      this.medicalAnswer = '';
      this.extraAnswer = '';
      this.askSwimTIme = '00:00:00';
      this.askBikeTime = '00:00:00';
      this.askRunTime = '00:00:00';
      this.selectedMerchSize = null;
      this.selectedMerchAmount = null;
      this.selectedRace = null;
      this.selectedMerchList = [];
      this.raceRegistrationResult = [];
      this.racesList = [];
    },
    useCoopon() {
      let self = this;
      if (!self.cooponCode || self.cooponCode.length <= 0) {
        self.$showError('Coupon required!');
        return;
      }
      self.isProcessing = true;
      Request.addCoupons({
        raceId: this.$route.params.rId,
        code: self.cooponCode,
      }).then(
        response => {
          self.isProcessing = false;
          if (response && response.body && response.body.isSuccess) {
            self.isShowCoopon = true;
            self.loadCartNew();
          } else {
            self.isProcessing = false;
            if (response.body.message) self.$showError(response.body.message);
            else
              self.$showError('Something went wrong. Contact with DEV team!');
          }
        },
        () => {
          self.isProcessing = false;
          self.$showError('Something went wrong. Contact with DEV team!');
        }
      );
    },
    resetCart() {
      Request.resetCart().then(
        response => {},
        () => {}
      );
    },
  },
  async mounted() {
    await this.loadCookies();
    await this.loadCartNew();
    await this.getUserRegistrationList();
    await this.loadRaceInfo();
  },
};



// WEBPACK FOOTER //
// ./src/components/user/race-events/race-entry/layout/layout.js